// Browser-safe: the login page imports this. No server imports here.

/** The code the sign-in gate rejects a non-Nymbl Microsoft identity with (`?error=` on /login). */
export const NOT_NYMBL_ACCOUNT = "not_nymbl_account";

/** Better Auth's admin-plugin code (`?error=` on /login) for a banned user's Microsoft callback. */
export const BANNED_USER = "BANNED_USER";

const MESSAGES: Record<string, string> = {
  [NOT_NYMBL_ACCOUNT]:
    "That Microsoft account isn't a Nymbl account. Sign in with your @nymbl.app account.",
  [BANNED_USER]: "This account has been banned. Contact an admin if you believe this is an error.",
  access_denied: "Microsoft sign-in was cancelled.",
};

const GENERIC = "Microsoft sign-in didn't work. Try again, or ask an admin if it keeps happening.";

/** What the login page says for `?error=<code>`; null when there is no error. */
export function signInErrorMessage(code: string | undefined): string | null {
  if (!code) return null;
  return MESSAGES[code] ?? GENERIC;
}
